var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgYoutubeOffLogo = function SvgYoutubeOffLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3456 6.34574C24.058 5.26988 23.2106 4.42241 22.1347 4.13483C20.1847 3.61218 12.3647 3.61218 12.3647 3.61218C12.3647 3.61218 4.54469 3.61218 2.59469 4.13483C1.51883 4.42241 0.671361 5.26988 0.383779 6.34574C-0.13887 8.29574 -0.13887 12.3647 -0.13887 12.3647C-0.13887 12.3647 -0.13887 16.4336 0.383779 18.3836C0.671361 19.4595 1.51883 20.307 2.59469 20.5945C4.54469 21.1172 12.3647 21.1172 12.3647 21.1172C12.3647 21.1172 20.1847 21.1172 22.1347 20.5945C23.2106 20.307 24.058 19.4595 24.3456 18.3836C24.8683 16.4336 24.8683 12.3647 24.8683 12.3647C24.8683 12.3647 24.8683 8.29574 24.3456 6.34574Z",
    fill: "#FF0000",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.864 16.1157L16.3603 12.3647L9.864 8.61361V16.1157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.11913,
    y1: 2.90368,
    x2: 22.9037,
    y2: 21.8809,
    stroke: "#43418D",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYoutubeOffLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/youtube-off-logo.791ac73e.svg";
export { ForwardRef as ReactComponent };